import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useState, useRef, useEffect } from 'react';
import classNames from 'classnames';
import { Box } from '@hub/box';
import Icon from "@scentregroup/ui/components/icon";
import Spinner from "@scentregroup/ui/components/spinner";
import useFilteredCentres from '@scentregroup/shared/hooks/use-filtered-centres';
import useCustomCombobox from './use-custom-combobox';
import MenuToggle from './menu-toggle';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const DefaultCentreRow = _ref => {
  var _centre$title;

  let {
    centre
  } = _ref;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: (_centre$title = centre === null || centre === void 0 ? void 0 : centre.title) !== null && _centre$title !== void 0 ? _centre$title : ''
  });
};

const CentrePicker = _ref2 => {
  var _process, _process$env;

  let {
    inputType,
    haveMenuToggle,
    onNonSelected,
    as,
    sx,
    mainLabel,
    forceCentreName,
    autoSelectOnExactInputMatch,
    centres,
    pickerStyle: style,
    inputLabel,
    isLoading,
    centreToString,
    onInputValue,
    onCentreSelected,
    onFoundCentres,
    onFocus,
    CentreRow,
    isError,
    id
  } = _ref2;
  const [filteredCentres, filterCentres] = useFilteredCentres(centres, onFoundCentres);

  const itemToString = item => {
    if (item === null || item === undefined) {
      return '';
    } else if (centreToString) {
      return centreToString(item);
    } else {
      return item.title;
    }
  };

  const {
    inputValue,
    setInputValue,
    getLabelProps,
    getComboboxProps,
    getItemProps,
    getInputProps,
    getMenuProps,
    openMenu,
    closeMenu,
    isOpen,
    highlightedIndex
  } = useCustomCombobox({
    centres,
    filteredCentres,
    filterCentres,
    onCentreSelected,
    autoSelectOnExactInputMatch,
    itemToString,
    id
  });
  const MyCentreRow = CentreRow !== null && CentreRow !== void 0 ? CentreRow : DefaultCentreRow;
  useEffect(() => {
    onInputValue === null || onInputValue === void 0 ? void 0 : onInputValue(inputValue);
  }, [inputValue, onInputValue]);
  useEffect(() => {
    if (forceCentreName) {
      setInputValue(forceCentreName);
    }
  }, [forceCentreName, setInputValue]);
  const {
    0: inputHasFocus,
    1: setInputHasFocus
  } = useState(false);

  const onBlur = e => {
    const isInputSelected = forceCentreName && inputValue.toLowerCase() === forceCentreName.toLowerCase();
    const childGotFocus = e.currentTarget.contains(e.relatedTarget);

    if (!childGotFocus) {
      setInputHasFocus(false);

      if (!isInputSelected) {
        onNonSelected === null || onNonSelected === void 0 ? void 0 : onNonSelected();
      }
    }
  };

  const doShowClear = inputHasFocus && inputValue.length > 0;

  const clearInput = () => setInputValue('');

  const inputRef = useRef(null); // Hacky but we want to suppress false positive downshift
  // rendering errors in test runs:
  // eslint-disable-next-line no-process-env

  const getPropsConfig = {
    suppressRefError: ((_process = process) === null || _process === void 0 ? void 0 : (_process$env = _process.env) === null || _process$env === void 0 ? void 0 : _process$env.NODE_ENV) === 'test'
  };
  return /*#__PURE__*/_jsxs(Box, {
    as: as,
    sx: sx,
    onBlur: onBlur,
    "data-id": "centre-picker_index_CentrePicker_Box",
    children: [mainLabel ? /*#__PURE__*/_jsx("label", _objectSpread(_objectSpread({}, getLabelProps()), {}, {
      "data-id": "centre-picker_index_CentrePicker_label",
      children: mainLabel
    })) : null, /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({}, getComboboxProps()), {}, {
      className: classNames(style.combobox, {
        [style.error]: isError
      }),
      "data-id": "centre-picker_index_CentrePicker_Box_div",
      children: [/*#__PURE__*/_jsx(Icon, {
        type: "search",
        size: "small",
        className: style.CentreSearchIcon,
        "data-id": "centre-picker_index_CentrePicker_div_Icon"
      }), /*#__PURE__*/_jsx("input", _objectSpread(_objectSpread({}, getInputProps({
        ref: inputRef,
        disabled: isLoading,
        autoCorrect: 'off',
        type: inputType !== null && inputType !== void 0 ? inputType : 'search',
        name: 'centreSearch',
        placeholder: inputLabel !== null && inputLabel !== void 0 ? inputLabel : '',
        className: style.input,
        onFocus: () => {
          onFocus === null || onFocus === void 0 ? void 0 : onFocus();

          if (!isOpen) {
            openMenu();
          }

          setInputHasFocus(true);
        }
      }, getPropsConfig)), {}, {
        "data-test-id": "centre-search",
        "data-id": "centre-picker_index_CentrePicker_div_input"
      })), isLoading && /*#__PURE__*/_jsx("div", {
        className: style['spinner-container'],
        "data-id": "centre-picker_index_CentrePicker_div",
        children: /*#__PURE__*/_jsx(Spinner, {
          "data-id": "centre-picker_index_CentrePicker_div_Spinner"
        })
      }), haveMenuToggle && /*#__PURE__*/_jsx(MenuToggle, {
        doShowClear,
        clearInput,
        isOpen,
        openMenu,
        closeMenu,
        style,
        "data-id": "centre-picker_index_CentrePicker_MenuToggle"
      })]
    })), /*#__PURE__*/_jsx("ul", _objectSpread(_objectSpread({}, getMenuProps(undefined, getPropsConfig)), {}, {
      className: classNames({
        [style['filtered-centres']]: isOpen
      }),
      "data-id": "centre-picker_index_CentrePicker_Box_ul",
      children: isOpen && (filteredCentres.length ? filteredCentres.map((centre, index) => /*#__PURE__*/_jsx("li", _objectSpread(_objectSpread({
        tabIndex: -1 // This lets onBlur receive this elem as relatedTarget
        ,
        className: classNames(style.centre, {
          [style['highlighted-centre']]: highlightedIndex === index
        })
      }, getItemProps({
        item: centre,
        index
      })), {}, {
        "data-id": "centre-picker_index_CentrePicker_li",
        children: /*#__PURE__*/_jsx(MyCentreRow, {
          centre: centre,
          "data-id": "centre-picker_index_CentrePicker_li_MyCentreRow"
        })
      }), "".concat(itemToString(centre)).concat(index))) : /*#__PURE__*/_jsx("li", _objectSpread(_objectSpread({
        className: classNames(style['no-results'], style.centre)
      }, getItemProps({
        item: null,
        index: 0
      })), {}, {
        "data-id": "centre-picker_index_CentrePicker_li",
        children: /*#__PURE__*/_jsx(MyCentreRow, {
          "data-id": "centre-picker_index_CentrePicker_li_MyCentreRow"
        })
      }), "no-results"))
    }))]
  });
};

export default CentrePicker;